/**
 * "Not now" hides the personal setup nudge for 14 days per band. A per-viewer convenience, so browser storage is
 * acceptable; every access is guarded, and with no storage the nudge simply shows.
 */

interface KeyValueStore {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
}

const snoozeMs = 14 * 24 * 60 * 60 * 1000
const key = (bandId: string) => `tunasong.rider.setupNudge.${bandId}`

/** `window.localStorage`, or undefined where reading it throws (blocked site data, some private windows) */
export const browserStorage = (): KeyValueStore | undefined => {
  try {
    return typeof window === 'undefined' ? undefined : window.localStorage
  } catch {
    return undefined
  }
}

export const isNudgeSnoozed = (bandId: string, now: Date, storage: KeyValueStore | undefined = browserStorage()) => {
  try {
    const until = Number(storage?.getItem(key(bandId)))
    return Number.isFinite(until) && until > now.getTime()
  } catch {
    return false
  }
}

export const snoozeNudge = (bandId: string, now: Date, storage: KeyValueStore | undefined = browserStorage()) => {
  try {
    storage?.setItem(key(bandId), String(now.getTime() + snoozeMs))
  } catch {
    // Storage is a convenience: without it, the nudge shows again next time
  }
}
